exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ellipsis-text[data-v-255c2f8a] {\n  display: inline-block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.table_pagination[data-v-255c2f8a] {\n  margin-top: 20px;\n  text-align: right;\n}\n", ""]);

// exports
